import styled from "styled-components"
import media from "styled-media-query"

export const LogoWrapper = styled.div``

export const LogoImage = styled.img`
  height: ${props => (props.small ? "auto" : "5em")};
  /* margin-left: ${props => (props.small ? "0" : "0")}; */
  width: ${props => (props.small ? "9.5em" : "11em")};

  ${media.lessThan("small")`
    height: auto;
    width: 9em;
  `}
`
